export default __webpack_public_path__ + "static/media/bot-happy.16c0765d.png";